import React from "react";
import EventCard from "./EventCard.js";
import SearchFriends from "./SearchFriends.js";

const FormPageFour = () => {
  return (
    <div className="formPageFourContainer">
      <EventCard />
      <SearchFriends />
    </div>
  );
};

export default FormPageFour;
